import createStore from './store/store';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import reportWebVitals from './reportWebVitals';
import AppRouter from './router/index';
import './root.scss';
import dayjs from 'dayjs';
import RelativeTimeDayjs from 'dayjs/plugin/relativeTime';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const { store, persistor } = createStore();

dayjs.extend(RelativeTimeDayjs);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AppRouter />
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
